import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Field, useFormikContext } from 'formik';
import DateTimePickerFormik from 'app/components/form/formik/DateTimePickerFormik';
import { IntegrityForm } from 'features/settings/integrityManagement/helpers/integrityManagement.constants';
import { debounce } from 'lodash';

const useStyles = makeStyles((theme) => ({
  dateTimePicker: {
    marginBottom: theme.spacing(0),
  },
}));

const TimeRuleDataFormComponent = ({ integrity, updateValue, xs = 6 }) => {
  const classes = useStyles();
  const { values } = useFormikContext();

  const isValidDateFormat = (dateStr) => {
    const dateRegex = /^\d{4}\/\d{2}\/\d{2} \d{2}:\d{2}$/;
    return dateRegex.test(dateStr);
  };

  const debouncedUpdateValue = debounce((newValues) => {
    if (isValidDateFormat(newValues.value)) {
      updateValue(newValues);
    }
  }, 500);

  useEffect(() => {
    if (integrity.value !== values.value) debouncedUpdateValue(values);
    // eslint-disable-next-line
  }, [values]);

  return (
    <Grid item xs={xs}>
      <Field name={IntegrityForm.VALUE}>
        {({ form, ...formik }) => (
          <DateTimePickerFormik
            className={classes.dateTimePicker}
            autoOk
            placeholder="yyyy/mm/dd hh:mm"
            form={form}
            {...formik}
          />
        )}
      </Field>
    </Grid>
  );
};

export default TimeRuleDataFormComponent;
